<script>
    export let progress;
</script>

<p class="body_text" style="font-size: 10px; margin-bottom: 0px">upload in progress: {Math.floor(progress * 1000) / 1000}%</p>
<div style="position: relative; height: 5px; border: 1px solid white; width: 100%">
  <div style="position: absolute; left: 0; top: 0; bottom: 0; width: {progress}%; background-color: white" />
</div>